/************
 * List Tab Detail with right hand properties drawer
 * File Name ...: document-categories.components.ts
 * Generated By : vishnu on 01/22/24
 * Date ........: 01/22/24
 /************/

import {Component, OnInit, ViewChild, HostListener, AfterContentInit} from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import {MatSort} from '@angular/material/sort';
import {Settings} from '../../../services/settings';
import {ValidationResult} from '../../../models/validation-result';
import {
    ConfirmDialogComponent,
    ConfirmDialogModel
} from '../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {TransactionHistoryService} from '../../../services/transactionhistory.service';
import {TransactionHistoryComponent} from '../../../components/transaction-history/transaction-history';
import {DwUtils} from '../../../components/utils/dw-utils';
import {CaseDocumentService} from "../../../services/documents.service";
import {DocumentCategory} from "../../../models/document-category";

@Component({
  selector: 'app-document-categories',
  templateUrl: './document-categories.component.html',
  styleUrls: ['./document-categories.component.css']
})
export class DocumentCategoriesComponent {
	/*** Header / Query Strip Variables ****/
    public formTitle = 'Document Categories';
    public pagination: string;

    /*** Editing variables ***/
    public isEditing: boolean | null = false;
    public isAdd: boolean | null = false;
    public records: any;
    public selectedRecord: DocumentCategory;
    public historyRecord: DocumentCategory;
    public Idx: number | null = -1;
    public strErr: string | null = '';
    public dataSource: MatTableDataSource<any>;

    public result: boolean | null = false;
    public disabledFlag: boolean | null = true;


    /**** Query strip filter settings ***/
    public selectedStatusFilter: string | null = 'Active';
    public contentClassWithBanner: string | null = 'dwtable-container';
    public contentClassWithoutBanner: string | null = 'dwtable-container-without-header';
    public contentClassName: string | null = 'dwtable-container';

    /*** Record Table / card table  ***/
    public displayedColumns: string[] = ['id', 'description', 'activeStatus'];

    /***** Control Strip Button Visibility ***/
    public visibleAdd: boolean | null = false;
    public visibleModify: boolean | null = false;
    public visibleDelete: boolean | null = false;

    /***** Tab Detail Section *****/
    public selectedTabIndex: number | null = 0;

    public id: any | null = '';
    public description: any | null = '';
    public activeStatus: any | null = '';

    public busyCursor: boolean = false;

    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild('history', {static: true}) history: TransactionHistoryComponent;

    constructor(private documentService: CaseDocumentService,
                private txService: TransactionHistoryService,
                public dialog: MatDialog) {
        this.selectedRecord = new DocumentCategory();
    }

    public ngOnInit() {
        if(Settings.getInstance().hasPrivilege("SETTINGS_DOCUMENT_CATEGORIES", "WRITE")) {
            this.visibleAdd = true;
            this.visibleModify = true;
            this.visibleDelete = false;
        }
    }
    public ngAfterContentInit() {

        this.queryRecords();

        if (Settings.getInstance().enableMessageBanner) {
            this.contentClassName = this.contentClassWithBanner;
        } else {
            this.contentClassName = this.contentClassWithoutBanner;
        }
    }
    /*** Query Records from the Service ***/
    public queryRecords() {
        this.busyCursor = true;
        this.documentService.getAllDocumentCategories().subscribe(
            (result) => {
                this.busyCursor = false;
                this.records = result;
                this.dataSource = new MatTableDataSource(this.records);
                this.dataSource.sort = this.sort;
                this.setPagination(-1, this.dataSource.data.length);
                this.onChangeStatusFilterValue();
            },
            (error) => {
                Settings.getInstance().handleError(error,'Error: unable to retrieve unit of measure data from the' +
                    ' service');
                this.busyCursor = false;
            }
        );
    }
    /*** Display the number of records from the total ***/
    public setPagination(idx: number, total: number) {
        this.pagination = (idx + 1) + '/' + total;
    }
    public onChangeStatusFilterValue() {
        const dataTemp: DocumentCategory[] = [];
        this.clearFilter();

        for (const rec of this.records) {
            if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
                dataTemp.push(rec);
            }
        }
        this.dataSource = new MatTableDataSource(dataTemp);
        this.setPagination(-1, this.dataSource.filteredData.length);
    }
    public onStatusChange() {

        this.documentService.updateDocumentCategory(this.selectedRecord).subscribe(
            () => {
                // no user feedback, just apply the filter ...
                this.onChangeStatusFilterValue();
            });
    }
    public doTabChange(): void {

    }
    @HostListener('matSortChange', ['$event'])
    public onSortChange(event: any) {

        if (event.direction === 'asc') {
            if (event.active === 'id') {
                this.records.sort((a, b) =>
                    a[event.active] - (b[event.active]));
            }
            else {
                this.records.sort((a, b) =>
                    a[event.active].localeCompare(b[event.active]));
            }
        } else {
            if (event.active === 'id') {
                this.records.sort((a, b) =>
                    b[event.active] - (a[event.active]));
            }
            else {
                this.records.sort((a, b) =>
                    b[event.active].localeCompare(a[event.active]));
            }
        }
        this.dataSource.data = this.records;
        this.onChangeStatusFilterValue();
        this.selectRow();
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
    }
    public clearFilter() {
        if (this.isEditing) {
            return;
        }
        this.unSelectRow();
        this.dataSource.filter = '';
        this.selectRow();
        this.setPagination(-1, this.dataSource.data.length);
    }
    public applyFilter(filterValue: string) {
        if (this.isEditing) {
            return;
        }
        this.dataSource.filter = filterValue.trim().toLowerCase();
        this.unSelectRow();
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
    }
    public selectRow() {
        if (this.selectedRecord.id === 0) {
            this.unSelectRow();
            return;
        }
        this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
    }
    public unSelectRow() {

        this.Idx = -1;
        this.selectedRecord = new DocumentCategory();
        this.setPagination(this.Idx, this.dataSource.data.length);
        this.displayDetail(this.selectedRecord);

    }
    public displayDetail(record: DocumentCategory) {
        if (record === undefined) {
            return;
        }
        this.id = record.id;
        this.description = record.description;
        this.activeStatus = record.activeStatus;
        this.history.onShowHandler('DocumentCategories', 'id', record.id.toString());
    }
    public clear() {
        this.id = '';
        this.description = '';

        this.activeStatus = '';
    }
    public addModifyRecord(isAdd: boolean) {
        this.isAdd = isAdd;
        this.isEditing = true;
        this.selectedTabIndex = 0;

        if (this.isAdd) {
            this.clear();
            this.id = 0;
            this.activeStatus = 'Active';
        } else {
            // store the history record
            this.historyRecord = this.selectedRecord;
        }

        DwUtils.setFocus('description');
    }
    public removeRecord() {
        const message = 'Remove Document Category: "' + this.selectedRecord.description + '" - Are you sure?';
        const dialogData = new ConfirmDialogModel('Please Confirm', message);

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            data: dialogData,
            panelClass: 'custom-dialog-container'
        });

        dialogRef.afterClosed().subscribe(dialogResult => {
            this.result = dialogResult;
            if (this.result === true) {
                this.documentService.deleteDocumentCategory(this.selectedRecord.id).subscribe(
                    () => {
                        // remove the row from the table.

                        this.records.splice(this.Idx, 1);
                        this.dataSource.data = this.records;
                        this.clear();
                    },
                    (error) => {
                        Settings.getInstance().handleError(error);
                    });
            }
        });
    }
    public tableKeyDown(event: KeyboardEvent) {
        if (this.isEditing) {
            return;
        }

        const len: number = this.dataSource.filteredData.length;
        if (event.key === 'ArrowDown') {
            if (this.Idx < (len - 1)) {
                this.selectedRecord = this.dataSource.filteredData[++this.Idx];
                this.displayDetail(this.selectedRecord);
            }
        } else if (event.key === 'ArrowUp') {
            if (this.Idx > 0) {
                this.selectedRecord = this.dataSource.filteredData[--this.Idx];
                this.displayDetail(this.selectedRecord);
            }
        }
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
    }
    public validateFields(): boolean {

        this.strErr = '';
        const vr: ValidationResult = this.selectedRecord.validateRecord();

        if (vr.error.length > 0) {
            this.strErr = vr.error;
            DwUtils.setFocus(vr.focus_field);
            return false;
        }
        return true;
    }
    public submitRecord() {

        this.selectedRecord = new DocumentCategory();
        this.selectedRecord.id = this.id;
        this.selectedRecord.description = DwUtils.capitalize(this.description);
        this.selectedRecord.activeStatus = this.activeStatus;

        this.strErr = '';

        if (!this.validateFields()) {
            return;
        }
        if (this.isAdd === true) {
            this.documentService.createDocumentCategory(this.selectedRecord).subscribe(
                (result) => {
                    this.selectedRecord.id = result.id;
                    this.isEditing = false;
                    /*** add a transaction history record ***/
                    this.txService.createTransactionHistory('DocumentCategories', this.selectedRecord.id);
                },
                () => {
                    this.strErr = 'Error: The server could not add/submit this record';
                    return;
                }
            );
        } else {

            this.documentService.updateDocumentCategory(this.selectedRecord).subscribe(
                () => {
                    this.isEditing = false;
                },
                () => {
                    this.strErr = 'Error: The server could not update this record';
                    this.selectedRecord = this.historyRecord;
                    return;
                });

            /*** add a transaction history record ***/
            this.txService.updateTransactionHistory(this.historyRecord,
                this.selectedRecord, 'DocumentCategories', this.selectedRecord.id);
        }
        this.updateSelectedRow();
    }
    /* Update the record in the table's data source - without refreshing it */
    public updateSelectedRow(): void {
        if (this.isAdd === true) {
            // add the new record to the top.
            this.records.unshift(this.selectedRecord);
            this.dataSource.data = this.records;
            this.onChangeStatusFilterValue();
            this.Idx = 0;
        } else {
            const i: number = this.records.findIndex(r => r.id === this.selectedRecord.id);
            this.records[i] = this.selectedRecord;
            this.dataSource.data = this.records;
            this.onChangeStatusFilterValue();
            this.selectRow();
            this.setPagination(this.Idx, this.dataSource.filteredData.length);
        }
       // this.dataSource.sort = this.sort;
    }
    public onRowClicked(selected: any) {

        if (this.isEditing === true)
            return;

        this.Idx = this.dataSource.filteredData.findIndex(s => s.id === selected.id);

        this.selectedRecord = selected;
        this.selectRow();
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
        this.displayDetail(this.selectedRecord);
    }
    public cancelSubmitRecord() {
        this.strErr = '';
        this.isEditing = false;
        this.displayDetail(this.selectedRecord);
    }
}
